<template>
  <div class="task-comment-editor">
    <TelegramDualEditor
      :model-value="modelValue"
      :members="members"
      :project-id="projectId"
      :placeholder="placeholder"
      :enable-wysiwyg="true"
      :clipboard-upload-enabled="clipboardUploadEnabled"
      :attachment-context="attachmentContext"
      :attachment-draft-id="attachmentDraftId"
      min-height="120px"
      @update:modelValue="$emit('update:modelValue', $event)"
      @draft-created="$emit('draft-created', $event)"
      @upload-finished="$emit('upload-finished', $event)"
    >
      <template #toolbar-extra>
        <slot name="toolbar-extra"></slot>
      </template>
    </TelegramDualEditor>

    <div class="task-comment-actions">
      <button
        v-if="showPreview"
        class="btn-sm btn-secondary"
        :disabled="!previewEnabled"
        @click="$emit('preview')"
      >
        {{ s__('TaskDetail|Preview') }}
      </button>
      <button
        class="btn-sm btn-primary"
        :disabled="submitDisabled || submitting"
        @click="$emit('submit')"
      >
        {{ submitting ? s__('TaskDetail|Submitting...') : s__('TaskDetail|Comment') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { s__ } from '@/locale'
import TelegramDualEditor from '@/components/common/TelegramDualEditor.vue'

defineProps({
  modelValue: { type: String, default: '' },
  members: { type: Array, default: () => [] },
  projectId: { type: [String, Number], default: null },
  placeholder: { type: String, default: '' },
  showPreview: { type: Boolean, default: true },
  previewEnabled: { type: Boolean, default: true },
  submitDisabled: { type: Boolean, default: false },
  submitting: { type: Boolean, default: false },
  clipboardUploadEnabled: { type: Boolean, default: false },
  attachmentContext: { type: Object, default: () => ({}) },
  attachmentDraftId: { type: [String, Number], default: null },
})

defineEmits(['update:modelValue', 'preview', 'submit', 'draft-created', 'upload-finished'])
</script>

<style scoped>
.task-comment-actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

@media (max-width: 768px) {
  .task-comment-actions {
    width: 100%;
    flex-wrap: wrap;
  }

  .task-comment-actions > .btn-sm {
    flex: 1 1 calc(50% - 4px);
    min-width: 0;
    justify-content: center;
    text-align: center;
  }
}
</style>
